import dayjs from 'dayjs';
import format from 'date-fns/format';

export const startDateTimeMinusWidth = (currentDate, type) => {
  const date = dayjs(currentDate).subtract(1, type)

  return format(date.$d, "yyyy-MM-dd'T'HH:mm:ssxxx")
}
